export default __webpack_public_path__ + "maps-examples-show-hide-layer-thumbnail-480-d7484306a0420e3e2213259c4927d24b.png";